import React from 'react';
import { Button } from 'antd';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Input from '../../components/form/Input';
import { required } from '../../components/form/validation';

import s from './style.less';

class ForgotInfo extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      error: null,
      tokenSent: false,
      email: '',
      loading: false,
    };
  }
  submit = async values => {
    try {
      this.setState({
        loading: true,
      });

      await fetch('/forgot-password-token', {
        method: 'post',
        body: values,
      });

      this.setState({
        error: null,
        tokenSent: true,
        email: values.email,
        loading: false,
      });
    } catch (e) {
      this.setState({
        error: e.message || e,
        loading: false,
      });
    }
  };

  render() {
    const { error, tokenSent, email, loading } = this.state;

    return (
      <div className={s.page}>
        <div className={s.page}>
          <div className={s.page__block}>
            <div className={s.container}>
              <div className={s.page__title}>Did you forget your password?</div>
              {!tokenSent && (
                <h5 className={s.text_center}>
                  Enter your email address below and we&apos;ll email you a link
                  where you can choose a new password
                </h5>
              )}
              <div className={s.row}>
                {error && (
                  <div className={s.error}>
                    No account with that email address exists.
                  </div>
                )}
                {!tokenSent && (
                  <div className={s.flex}>
                    <form onSubmit={this.props.handleSubmit(this.submit)}>
                      <div title="Please supply your email address.">
                        <Field
                          type="email"
                          name="email"
                          placeholder="E-mail address"
                          component={Input}
                          validate={required}
                        />
                      </div>
                      <Button
                        className={s.submit}
                        htmlType="submit"
                        type="primary"
                        disabled={loading}
                      >
                        Submit
                      </Button>
                    </form>
                  </div>
                )}
                {tokenSent && (
                  <div className={s.success}>
                    Click the link which you get on your email address ({email})
                    and, from there, you can choose a new password.
                    <br />
                    Don&apos;t forget to check your &apos;Promotions&apos; and
                    &apos;Junk&apos; folders if you don&apos;t see our email.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotInfo.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'forgot-info',
})(ForgotInfo);
